module.exports = {
  prefix: 'view',
  routerPreFix: {
    merchant: 'merchant'
  }
}